export const ReportType = {
    SALON: 'SALON_REPORT',
    SERVICES: 'SERVICES_REPORT',
    PRODUCTS: 'PRODUCTS_REPORT',
    EMPLOYEE_SALARY: 'EMPLOYEE_SALARY_REPORT',
    CASH_DEPOSIT: 'CASH_DEPOSIT_REPORT',
    EMPLOYEE_SALARY_DETAIL: 'EMPLOYEE_SALARY_DETAIL_REPORT',
    STAFF_SALARY_DETAIL: 'STAFF_SALARY_DETAIL_REPORT',
    CLOCK_TIME: 'CLOCK_TIME_REPORT',
    REVENUE: 'REVENUE_INCOME_REPORT',
};